<template>
    <h2 class="mb-3 mb-lg-5">Contact Us</h2>
    <form v-if="!formSubmitted" id="ContactForm" @submit.prevent="validate" action="#" class="position-relative">
        <Spinner :isAbsolute="true" :visible="isSubmitting" />
        <div class="row">
            <div class="col-md-6 form-group pb-3 mb-2">
                <label for="form-name">Name *</label>
                <input ref="nameInput" type="text" class="form-control" id="form-name" name="name" placeholder="Name"
                    required v-model="formData.name" />
                <i v-if="formValidate.name" class="text-danger mb-2">{{ formValidate.name }}</i>
            </div>
            <div class="col-md-6 form-group pb-3 mb-2">
                <label for="form-subject">Telephone</label>
                <input type="tel" class="form-control" id="form-subject" name="telephone" placeholder="Telephone"
                    v-model="formData.telephone" />
                <i v-if="formValidate.telephone" class="text-danger mb-2">{{ formValidate.telephone }}</i>
            </div>
        </div>
        <div class="form-group pb-3 mb-2">
            <label for="form-email">Email Address *</label>
            <input type="email" class="form-control" id="form-email" name="email" placeholder="Email Address"
                required v-model="formData.email" />
                <i v-if="formValidate.email" class="text-danger mb-2">{{ formValidate.email }}</i>
        </div>
        <div class="form-group pb-3 mb-2">
            <label for="form-message">Message *</label>
            <textarea class="form-control" id="form-message" name="message" placeholder="Message"
                required v-model="formData.message">
            </textarea>
            <i v-if="formValidate.message" class="text-danger mb-2">{{ formValidate.message }}</i>
        </div>
        
        <button class="btn btn-outline-dark text-uppercase rounded-0 mt-4 py-2 px-4 px-sm-5" type="submit">
            Submit Enquiry
        </button>
        
        <div v-if="formError" class="alert alert-danger mt-3">
            {{ formError }}
        </div>
    </form>
    <div v-else class="alert alert-success mt-3">
        Thank you for contacting us, we will get back to you shortly.
    </div>
</template>

<script setup lang="ts">
    import { ref, Ref, onMounted } from "vue"
    import { IReCaptchaComposition, useReCaptcha } from 'vue-recaptcha-v3'
    import router from "@/router"
    import Spinner from "@/components/general/Spinner.vue";

    var formData: Ref<any> = ref({
        name: "",
        telephone: "",
        email: "",
        message: ""
    })
    var formValidate: Ref<any> = ref({
        name: "",
        telephone: "",
        email: "",
        message: ""
    })
    const nameInput: Ref<any> = ref()
    var recapthcaObject: Ref<any | undefined> = ref(undefined)
    var isSubmitting: Ref<boolean> = ref(false)
    var formSubmitted: Ref<boolean> = ref(false)
    var formError: Ref<string | undefined> = ref(undefined)

    async function recaptcha(callback: any) {
      if (recapthcaObject) {
        const token = await recapthcaObject.value.executeRecaptcha(`${process.env.VUE_APP_FORM_KEY_CONTACT}`)
        callback(token)
      }
    }

    function validate () {
        var isValid = true
        Object.values(document.querySelectorAll("#ContactForm [required]")).forEach((input: any) => {
            const key = input.name
            const value = formData.value[key]
            if (value == null || value == "") {
                formValidate.value[key] = "This field is required."
                document.querySelector(`[name*='${key}']`)?.classList.add("invalid-flag")
                isValid = false
            }
            else {
                formValidate.value[key] = ""
                document.querySelector(`[name*='${key}']`)?.classList.remove("invalid-flag")
            }
        })
        if (!isValid) {
            return false
        }

        isSubmitting.value = true
        recaptcha((token: any) => {formPost(token)})
    }
    
    async function formPost (recaptchaResult: string) {
        const FormContent = formData.value
        const formKey = process.env.VUE_APP_FORM_KEY_CONTACT || ""
        const endpoint = process.env.VUE_APP_FORM_ENDPOINT ? process.env.VUE_APP_FORM_ENDPOINT+ "/api/forms/" + formKey : ""
        const store_only = process.env.VUE_APP_FORM_STORE_ONLY === "true" ? true : false
        const email = formData.value.email

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "GoogleRecaptchaResponse": recaptchaResult,
                FormContent,
                "StoreOnly": store_only,
                "EmailAddress": email
            })
        }

        formError.value = ""
        let res: any
        try {
            res = await fetch(endpoint, options)
                .then(result => {
                    if (result.status === 200) {
                        isSubmitting.value = false
                        formSubmitted.value = true
                        return result.json().then((data) => { /*Ref = data.resultData;*/ })
                    }
                    else {
                        isSubmitting.value = false
                        formError.value = 'Error submitting data.'
                    }
                })
        } catch (e: any) {
            isSubmitting.value = false
            formError.value = `Error submitting data. ${e}`
            throw new Error(e)
        }
    }

    onMounted(async () => {
        recapthcaObject.value = useReCaptcha() as IReCaptchaComposition
        setTimeout(() => {
            if (router.currentRoute.value.hash.includes("ContactUs") && nameInput.value != null) {
                nameInput.value.focus()
            }
        }, 200)
    })
</script>

<style scoped lang="scss">
    .form-control {
        border-radius: 0px;
        border: 3px solid #222222;
        border-right: none;
        border-top: none;
        border-bottom: none;
        background-color: #dfdfdf;
        &.invalid-flag {
            border-left-color: #dc3545;
        }
        &:focus {
            border-color: #86b7fe;
            background-color: #fff;
            box-shadow: 0 0 0 0.25rem rgba(13,110,253,.15);
        }
    }
</style>